import {Component} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {CustomerInfosService} from './customer-infos.service';
import {SpinnerService} from '../shared/spinner/spinner.service';
import {LocalStorageService} from '../shared/local-storage.service';
import {ThirdParty} from '../entity/third-party';
import {ProducerAutocompleteSearchResult} from '../shared/producers/producer-autocomplete-search-result';
import {environment} from '../../environments/environment';

const siretNumbersSize = 14;

@Component({
  selector: 'customer-infos-order',
  templateUrl: './customer-infos-order.component.html',
  styleUrls: ['./customer-infos-order.component.css']
})
export class CustomerInfosOrderComponent {

  private step: number;
  private producers: ThirdParty[] = [];
  producerSiretCountryPart: string = null;
  producerSiretNumbersPart: string = null;
  private selectedProducer: ThirdParty = null;
  private selectedProducerBackup: ThirdParty = null;
  private sampleTurn: string = null;
  private newSampleTurn: string = null;
  private defaultDairy: any = null;
  private defaultColl: any = null;
  private defaultTrackingTechnician: any = null;
  private newDefaultDairy: any = null;
  private newDefaultColl: any = null;
  private newDefaultTrackingTechnician: any = null;
  private repriseHistorique: boolean = true;
  private effectiveDate: any = null;
  private uploadingFile: boolean;
  private filename: string = '';
  private newDairyExists: boolean;
  private newCollExists: boolean;
  private newTrackingTechnicianExists: boolean;
  private checked: boolean[];
  comment: string;
  recapDiff = {};
  newProducerAgreement: any = null;
  producerAgreement: any = null;
  agreements: any = [];
  productionKinds: any = [];
  producersList: ThirdParty[] = [];
  producersListSearch: string = null;
  productionKindsAgreementsMapping: any = [];
  isSearchingDairyRelation: boolean;
  isSearchingCollRelation: boolean;
  isSearchingTrackingTechnicianRelation: boolean;

  constructor(private router: Router,
              private route: ActivatedRoute,
              private customerInfosService: CustomerInfosService,
              private localStorageService: LocalStorageService,
              private spinnerService: SpinnerService) {
    this.route.params.subscribe(
      params => {
        this.step = parseInt(params['step']);
      }
    );
  }

  ngOnInit(): void {
    this.uploadingFile = false;
    if (this.step == 1) {
      this.clearAll();
    }

    this.loadAll();
  }

  ngDoCheck(): void {
    if (this.step == 1) {
      const data = this.route.snapshot.data['data'];
      this.agreements = data[0];
      this.productionKinds = data[1];
      this.productionKindsAgreementsMapping = data[2];
    } else if (
      this.step == 2 &&
      (
        !this.newProducerAgreement ||
        !this.producerAgreement ||
        !this.sampleTurn ||
        !this.defaultDairy ||
        !this.defaultColl ||
        !this.defaultTrackingTechnician
      )
    ) {
      const data = this.route.snapshot.data['data']
      this.newProducerAgreement = data[0];
      this.sampleTurn = data[1];
      this.newSampleTurn = data[1];
      this.defaultDairy = data[2].laiteAppRelation ? data[2].laiteAppRelation.parentThirdParty : this.createEmptyDefaultParentTP();
      this.newDefaultDairy = data[2].laiteAppRelation ? data[2].laiteAppRelation.parentThirdParty : this.createEmptyDefaultParentTP();
      this.defaultColl = data[2].laiteCollRelation ? data[2].laiteCollRelation.parentThirdParty : this.createEmptyDefaultParentTP();
      this.newDefaultColl = data[2].laiteCollRelation ? data[2].laiteCollRelation.parentThirdParty : this.createEmptyDefaultParentTP();
      this.defaultTrackingTechnician = data[2].trackingTechnicianRelation ? data[2].trackingTechnicianRelation.parentThirdParty : this.createEmptyDefaultParentTP();
      this.newDefaultTrackingTechnician = data[2].trackingTechnicianRelation ? data[2].trackingTechnicianRelation.parentThirdParty : this.createEmptyDefaultParentTP();
      this.producerAgreement = JSON.parse(JSON.stringify(data[0]));
    } else if (this.step == 3) {
      this.computeRecapDiff();
    }
  }

  private createEmptyDefaultParentTP() {
    return {
      identity: null,
      label: null
    };
  }

  public goToStep(event: any, step: number): void {
    event.preventDefault();
    if (step < this.step) {
      this.updateStep(step);
    }
  }

  public back(event: any): void {
    event.preventDefault();
    this.prevStep();
  }


  public next(event: any): void {
    event.preventDefault();
    this.nextStep();
  }

  private nextStep(): void {
    let step = this.step + 1;
    this.updateStep(step);
  }

  private prevStep(): void {
    if (this.step > 1) {
      let step = this.step - 1;
      this.updateStep(step);
    }
  }

  private updateStep(step): void {
    this.saveAll();
    this.router.navigate(['customer-infos-order/' + step]);
  }

  public displayPrev(): boolean {
    let display = false;
    switch (this.step) {
      case 2 :
        display = true;
        break;
      case 3 :
        display = true;
        break;
      default:
        display = false;
    }
    return display;
  }

  public displayNext(): boolean {
    let display = false;
    switch (this.step) {
      case 1 :
        display = true;
        break;
      case 2:
        display = true;
        break;
      default:
        display = false;
    }
    return display;
  }

  public stepIsValid(): boolean {
    let valid = false;
    switch (this.step) {
      case 1:
        valid = this.selectedProducer != null;
        break;
      case 2 :
        valid = this.checkInfosValid()
          && !this.uploadingFile
          && !this.isSearchingCollRelation
          && !this.isSearchingDairyRelation
          && !this.isSearchingTrackingTechnicianRelation
        ;
        break;
      case 3 :
        valid = true;
        break;
      default:
        valid = false;
    }
    return valid;
  }

  public selectProducer(data: ProducerAutocompleteSearchResult): void {
    const producer = data.selectedProducer;
    const producers = data.fetchedProducers;
    const search = data.search;
    this.selectedProducer = producer;
    this.selectedProducerBackup = new ThirdParty();
    this.selectedProducerBackup.fromJSON(producer);
    if (this.selectedProducer) {
      this.selectedProducer['address1'] = this.selectedProducer.getDefaultAddress() ? this.selectedProducer.getDefaultAddress().address1 : null;
      this.selectedProducer['city'] = this.selectedProducer.getDefaultAddress() ? this.selectedProducer.getDefaultAddress().city : null;
      this.selectedProducer['postalCode'] = this.selectedProducer.getDefaultAddress() ? this.selectedProducer.getDefaultAddress().postalCode : null;
    }
    const siret = this.selectedProducer.siret;
    if (siret) {
      const siretLength = siret.length;
      if (siretLength > siretNumbersSize) {
        this.producerSiretCountryPart = siret.substring(0, siretLength - siretNumbersSize);
        this.producerSiretNumbersPart = siret.substr(-siretNumbersSize);
      } else {
        this.producerSiretNumbersPart = siret;
      }
    }

    this.producersList = producers;
    this.producersListSearch = search;
  }

  /**
   * Display the identity and the label of the parent third party of a relation
   * @param thirdParty
   * @returns {any}
   */
  public displayTPOfDefaultRelation(thirdParty: any) {
    if (thirdParty && (thirdParty.identity || thirdParty.label)) {
      return thirdParty.identity + ' - ' + (thirdParty.label || '');
    }

    return null;
  }

  public selectDairy(dairy: any) {
    this.newDefaultDairy = dairy.thirdParty;
    this.newDairyExists = dairy.found;
  }

  public updateDairySearch(isSearching: boolean) {
    this.isSearchingDairyRelation = isSearching;
  }

  public updateCollSearch(isSearching: boolean) {
    this.isSearchingCollRelation = isSearching;
  }

  public updateTrackingTechnicianSearch(isSearching: boolean) {
    this.isSearchingTrackingTechnicianRelation = isSearching;
  }

  public selectColl(collect: any) {
    this.newDefaultColl = collect.thirdParty;
    this.newCollExists = collect.found;
  }

  public selectTrackingTechnician(trackingTechnician: any) {
    this.newDefaultTrackingTechnician = trackingTechnician.thirdParty;
    this.newTrackingTechnicianExists = trackingTechnician.found;
  }

  public getAgreementById(agreementId: string) {
    for (let agreementCode in this.agreements) {
      if (!this.agreements.hasOwnProperty(agreementCode)) continue;
      if (this.agreements[agreementCode].id === agreementId) {
        return this.agreements[agreementCode];
      }
    }
    return {label: null};
  }

  public checkInfosValid() {
    let valid = true;
    valid = valid && this.validateSiret(this.producerSiretNumbersPart);
    valid = valid && this.validatePhoneNumber(this.selectedProducer.getDefaultContact().phone);
    valid = valid && this.validateEDE(this.selectedProducer.ede);
    valid = valid && this.selectedProducer.identity.length > 0;
    valid = valid && this.selectedProducer.businessName.length > 0;
    valid = valid && this.effectiveDate;
    return valid;
  }

  validateSiret(siret: string) {
    // Check int
    if (isNaN(parseInt(siret))) {
      return false;
    }

    // Siret validation rule
    // 1. Multiply by 1 the odd positioned numbers starting from the right
    // 2. Multiply by 2 the even positioned numbers starting from the right
    // 3. If the sub number is >= 10, sum its digit (ex: 11 => 1+1, 18 => 1+9). Same as substracting 9 if >= 10
    // 4. The sum of all this should be a multiple of 10
    let sum = 0;
    let num;
    for (let i = 1; i <= siret.length; i++) {
      num = siret.charAt(siret.length - i);
      num = parseInt(num, 10);
      if ((i % 2) === 0) {
        num *= 2;
      }
      if (num > 9) {
        num -= 9;
      }
      sum += num;
    }
    if ((sum % 10) !== 0) {
      return false;
    }

    return true;
  }

  validatePhoneNumber(phoneNumber: string) {
    if (!phoneNumber || phoneNumber.length === 0) {
      return true;
    }

    return this.checkValIsOnlyDigits(phoneNumber) && phoneNumber.length === 10;
  }

  validateEffectiveDate(effetiveDate: string) {
      if (!effetiveDate || effetiveDate.length === 0) {
          return false;
      }

      return true;
  }

  private checkValIsOnlyDigits(value: string) {
    let chars = value.split('');
    for (let i in chars) {
      let char = chars[i];
      if (isNaN(parseInt(char, 10))) {
        return false;
      }
    }

    return true;
  }

  validateEDE(ede: string) {
    return this.checkValIsOnlyDigits(ede) && ede.length === 8;
  }

  updateFilename(filename) {
    this.filename = filename;
  }

  updateUploadingFile(isUploading) {
    this.uploadingFile = isUploading;
  }

  onProductionKindChange() {
    // each time the production kind changes, we choose the first agreement among the available one according to this new production kind
    const firstAgreementCode = this.productionKindsAgreementsMapping[this.selectedProducer.productionKind].slice(0, 1);
    this.newProducerAgreement.id = this.agreements[firstAgreementCode].id;
  }

  /**
   * Get the path of access an uploaded file
   * @returns string|null
   */
  getFilePath() {
    if (this.filename) {
      return environment.uploadFolderUrl + this.filename;
    }
    return null;
  }

  computeRecapDiff() {
    this.recapDiff['siret'] = this.selectedProducerBackup.siret === (this.producerSiretCountryPart + this.producerSiretNumbersPart);
    this.recapDiff['identifier'] = this.selectedProducerBackup.identity === this.selectedProducer.identity;
    this.recapDiff['ede'] = this.selectedProducerBackup.ede === this.selectedProducer.ede;
    this.recapDiff['label'] = this.selectedProducerBackup.businessName === this.selectedProducer.businessName;
    this.recapDiff['name'] = this.selectedProducerBackup.getDefaultContact().lastName === this.selectedProducer.getDefaultContact().lastName;
    this.recapDiff['firstName'] = this.selectedProducerBackup.getDefaultContact().firstName === this.selectedProducer.getDefaultContact().firstName;
    this.recapDiff['phone'] = this.selectedProducerBackup.getDefaultContact().phone === this.selectedProducer.getDefaultContact().phone;
    this.recapDiff['mobile'] = this.selectedProducerBackup.getDefaultContact().mobile === this.selectedProducer.getDefaultContact().mobile;
    this.recapDiff['mail'] = this.selectedProducerBackup.getDefaultContact().mail === this.selectedProducer.getDefaultContact().mail;
    this.recapDiff['address'] = this.selectedProducerBackup.getDefaultAddress().address1 === this.selectedProducer['address1'];
    this.recapDiff['city'] = this.selectedProducerBackup.getDefaultAddress().city === this.selectedProducer['city'];
    this.recapDiff['postalCode'] = this.selectedProducerBackup.getDefaultAddress().postalCode === this.selectedProducer['postalCode'];
    this.recapDiff['productionKind'] = this.selectedProducerBackup.productionKind === this.selectedProducer.productionKind;
    this.recapDiff['agreement'] = this.getAgreementById(this.producerAgreement.id).label === this.getAgreementById(this.newProducerAgreement.id).label;
    this.recapDiff['sampleTurn'] = this.sampleTurn === this.newSampleTurn;
    this.recapDiff['defaultDairy'] = this.defaultDairy.identity === this.newDefaultDairy.identity;
    this.recapDiff['defaultColl'] = this.defaultColl.identity === this.newDefaultColl.identity;
    this.recapDiff['defaultTrackingTechnician'] = this.defaultTrackingTechnician.identity === this.newDefaultTrackingTechnician.identity;
  }

  public sendModificationOrder(event: any) {
    event.preventDefault();
    this.spinnerService.start('Envoi de la demande');
    let data = new Object();
    let newState = new Object();
    let previousState = new Object();
    newState['siret'] = this.producerSiretCountryPart + this.producerSiretNumbersPart;
    newState['identity'] = this.selectedProducer.identity;
    newState['ede'] = this.selectedProducer.ede;
    newState['businessName'] = this.selectedProducer.businessName;
    newState['lastName'] = this.selectedProducer.getDefaultContact().lastName;
    newState['firstName'] = this.selectedProducer.getDefaultContact().firstName;
    newState['phone'] = this.selectedProducer.getDefaultContact().phone;
    newState['mobile'] = this.selectedProducer.getDefaultContact().mobile;
    newState['mail'] = this.selectedProducer.getDefaultContact().mail;
    newState['address1'] = this.selectedProducer['address1'];
    newState['city'] = this.selectedProducer['city'];
    newState['postalCode'] = this.selectedProducer['postalCode'];
    newState['agreementId'] = this.newProducerAgreement.id;
    newState['productionKind'] = this.selectedProducer.productionKind;
    newState['reprise'] = this.repriseHistorique;
    newState['sampleTurn'] = this.newSampleTurn;
    newState['defaultDairy'] = this.newDefaultDairy;
    newState['defaultDairyFound'] = this.newDairyExists;
    newState['defaultColl'] = this.newDefaultColl;
    newState['defaultCollFound'] = this.newCollExists;
    newState['defaultTrackingTechnician'] = this.newDefaultTrackingTechnician;
    newState['defaultTrackingTechnicianFound'] = this.newTrackingTechnicianExists;
    previousState['siret'] = this.selectedProducerBackup.siret;
    previousState['identity'] = this.selectedProducerBackup.identity;
    previousState['ede'] = this.selectedProducerBackup.ede;
    previousState['businessName'] = this.selectedProducerBackup.businessName;
    previousState['lastName'] = this.selectedProducerBackup.getDefaultContact().lastName;
    previousState['firstName'] = this.selectedProducerBackup.getDefaultContact().firstName;
    previousState['phone'] = this.selectedProducerBackup.getDefaultContact().phone;
    previousState['mobile'] = this.selectedProducerBackup.getDefaultContact().mobile;
    previousState['mail'] = this.selectedProducerBackup.getDefaultContact().mail;
    previousState['address1'] = this.selectedProducerBackup.getDefaultAddress().address1;
    previousState['city'] = this.selectedProducerBackup.getDefaultAddress().city;
    previousState['postalCode'] = this.selectedProducerBackup.getDefaultAddress().postalCode;
    previousState['agreementId'] = this.producerAgreement.id;
    previousState['productionKind'] = this.selectedProducerBackup.productionKind;
    previousState['reprise'] = this.repriseHistorique;
    previousState['sampleTurn'] = this.sampleTurn;
    previousState['defaultDairy'] = this.defaultDairy;
    previousState['defaultColl'] = this.defaultColl;
    previousState['defaultTrackingTechnician'] = this.defaultTrackingTechnician;
    data['new'] = newState;
    data['previous'] = previousState;
    data['filename'] = this.filename;
    data['effectiveDate'] = this.effectiveDate ? this.effectiveDate.formatted : null;
    data['comment'] = this.comment;
    this.customerInfosService.orderCustomerInfosModification(data).then(
      function (code: any) {
        this.orderCode = code;
        this.nextStep();
        this.clearAll();
        this.spinnerService.stop();
      }.bind(this),
      function () {
        this.spinnerService.stop();
      }.bind(this)
    );
  }

  /*********************/
  /*****  Storage  *****/

  /*********************/

  public saveAll(): void {
    let directory = 'mylab_customer_infos';
    this.localStorageService.save(directory, 'selectedProducer', this.selectedProducer);
    this.localStorageService.save(directory, 'selectedProducerBackup', this.selectedProducerBackup);
    this.localStorageService.save(directory, 'producerSiretNumbersPart', this.producerSiretNumbersPart);
    this.localStorageService.save(directory, 'producerSiretCountryPart', this.producerSiretCountryPart);
    this.localStorageService.save(directory, 'productionKinds', this.productionKinds);
    this.localStorageService.save(directory, 'agreements', this.agreements);
    this.localStorageService.save(directory, 'producersList', this.producersList);
    this.localStorageService.save(directory, 'producersListSearch', this.producersListSearch);
    this.localStorageService.save(directory, 'filename', this.filename);
    this.localStorageService.save(directory, 'productionKindsAgreementsMapping', this.productionKindsAgreementsMapping);
    this.localStorageService.save(directory, 'repriseHistorique', this.repriseHistorique);
    this.localStorageService.save(directory, 'effectiveDate', this.effectiveDate);
    if (this.step > 1) {
      this.localStorageService.save(directory, 'sampleTurn', this.sampleTurn);
      this.localStorageService.save(directory, 'newSampleTurn', this.newSampleTurn);
      this.localStorageService.save(directory, 'defaultDairy', this.defaultDairy);
      this.localStorageService.save(directory, 'newDefaultDairy', this.newDefaultDairy);
      this.localStorageService.save(directory, 'newDefaultDairyExists', this.newDairyExists);
      this.localStorageService.save(directory, 'defaultColl', this.defaultColl);
      this.localStorageService.save(directory, 'newDefaultColl', this.newDefaultColl);
      this.localStorageService.save(directory, 'newDefaultCollExists', this.newCollExists);
      this.localStorageService.save(directory, 'defaultTrackingTechnician', this.defaultTrackingTechnician);
      this.localStorageService.save(directory, 'newDefaultTrackingTechnician', this.newDefaultTrackingTechnician);
      this.localStorageService.save(directory, 'newDefaultTrackingTechnicianExists', this.newTrackingTechnicianExists);
      this.localStorageService.save(directory, 'newProducerAgreementId', this.newProducerAgreement.id);
      this.localStorageService.save(directory, 'producerAgreementId', this.producerAgreement.id);
      this.localStorageService.save(directory, 'comment', this.comment);
    }
  }

  public loadAll(): void {
    const directory = 'mylab_customer_infos';
    const selectedProducer = this.localStorageService.get(directory, 'selectedProducer', 'ThirdParty');
    if (selectedProducer) {
      this.selectedProducer = selectedProducer;
    }
    const producerSiretNumbersPart = this.localStorageService.get(directory, 'producerSiretNumbersPart', null);
    if (producerSiretNumbersPart) {
      this.producerSiretNumbersPart = producerSiretNumbersPart;
    }
    const producerSiretCountryPart = this.localStorageService.get(directory, 'producerSiretCountryPart', null);
    if (producerSiretCountryPart) {
      this.producerSiretCountryPart = producerSiretCountryPart;
    }
    const selectedProducerBackup = this.localStorageService.get(directory, 'selectedProducerBackup', 'ThirdParty');
    if (selectedProducerBackup) {
      this.selectedProducerBackup = selectedProducerBackup;
    }
    const producersList = this.localStorageService.get(directory, 'producersList', 'ThirdParty');
    if (producersList) {
      this.producersList = producersList;
    }
    const producersListSearch = this.localStorageService.get(directory, 'producersListSearch', null);
    if (producersListSearch) {
      this.producersListSearch = producersListSearch;
    }
    const agreements = this.localStorageService.get(directory, 'agreements', null);
    if (agreements) {
      this.agreements = agreements;
    }
    const productionKindsAgreementsMapping = this.localStorageService.get(directory, 'productionKindsAgreementsMapping', null);
    if (productionKindsAgreementsMapping) {
      this.productionKindsAgreementsMapping = productionKindsAgreementsMapping;
    }

    const productionKinds = this.localStorageService.get(directory, 'productionKinds', null);
    if (productionKinds) {
      this.productionKinds = productionKinds;
    }

    const filename = this.localStorageService.get(directory, 'filename', null);
    if (filename) {
      this.filename = filename;
    }

    const repriseHistorique = this.localStorageService.get(directory, 'repriseHistorique', null);
    if (repriseHistorique) {
      this.repriseHistorique = repriseHistorique;
    }

    const effectiveDate = this.localStorageService.get(directory, 'effectiveDate', null);
    if (effectiveDate) {
      this.effectiveDate = effectiveDate;
    }

    // we consider the agreements only when we've passed the first step
    if (this.step > 1) {
      const newProducerAgreementId = this.localStorageService.get(directory, 'newProducerAgreementId', null);
      if (newProducerAgreementId) {
        this.newProducerAgreement = {id: newProducerAgreementId};
      } else {
        this.newProducerAgreement = {id: null};
      }

      const producerAgreementId = this.localStorageService.get(directory, 'producerAgreementId', null);
      if (producerAgreementId) {
        this.producerAgreement = {id: producerAgreementId};
      } else {
        this.producerAgreement = {id: null};
      }
      const sampleTurn = this.localStorageService.get(directory, 'sampleTurn', null);
      if (sampleTurn) {
        this.sampleTurn = sampleTurn;
      }
      const newSampleTurn = this.localStorageService.get(directory, 'newSampleTurn', null);
      if (newSampleTurn) {
        this.newSampleTurn = newSampleTurn;
      }
      const defaultDairy = this.localStorageService.get(directory, 'defaultDairy', null);
      if (defaultDairy) {
        this.defaultDairy = defaultDairy;
      }
      const newDefaultDairy = this.localStorageService.get(directory, 'newDefaultDairy', null);
      if (newDefaultDairy) {
        this.newDefaultDairy = newDefaultDairy;
      }
      this.newDairyExists = this.localStorageService.get(directory, 'newDefaultDairyExists', null);
      const defaultColl = this.localStorageService.get(directory, 'defaultColl', null);
      if (defaultColl) {
        this.defaultColl = defaultColl;
      }
      const newDefaultColl = this.localStorageService.get(directory, 'newDefaultColl', null);
      if (newDefaultColl) {
        this.newDefaultColl = newDefaultColl;
      }
      this.newCollExists = this.localStorageService.get(directory, 'newDefaultCollExists', null);
      const defaultTrackingTechnician = this.localStorageService.get(directory, 'defaultTrackingTechnician', null);
      if (defaultTrackingTechnician) {
        this.defaultTrackingTechnician = defaultTrackingTechnician;
      }
      const newDefaultTrackingTechnician = this.localStorageService.get(directory, 'newDefaultTrackingTechnician', null);
      if (newDefaultTrackingTechnician) {
        this.newDefaultTrackingTechnician = newDefaultTrackingTechnician;
      }
      this.newTrackingTechnicianExists = this.localStorageService.get(directory, 'newDefaultTrackingTechnicianExists', null);

      const comment = this.localStorageService.get(directory, 'comment', null);
      if (comment) {
        this.comment = comment;
      }
    }
  }

  public clearAll(): void {
    this.localStorageService.clear('mylab_customer_infos', null);
    this.selectedProducer = null;
    this.selectedProducerBackup = null;
    this.repriseHistorique = true;
    this.effectiveDate = null;
    this.filename = '';
    this.producersListSearch = null;
    this.producersList = [];
    this.producerAgreement = null;
    this.newProducerAgreement = null;
    this.productionKinds = null;
    this.agreements = null;
    this.productionKindsAgreementsMapping = null;
    this.recapDiff = {};
    this.sampleTurn = null;
    this.newSampleTurn = null;
    this.defaultDairy = null;
    this.newDefaultDairy = null;
    this.defaultColl = null;
    this.newDefaultColl = null;
    this.defaultTrackingTechnician = null;
    this.newDefaultTrackingTechnician = null;
    this.newDairyExists = null;
    this.newCollExists = null;
    this.newTrackingTechnicianExists = null;
    this.comment = null;
  }
}


// WEBPACK FOOTER //
// ./src/app/customer-infos/customer-infos-order.component.ts